import { connect } from 'react-redux';

import VehicleTiles from 'inventory-listing/components/ResultVehicles/ResultVehicles.jsx';

function mapStateToProps(state) {
    return {
        vehicles: state.vehicles,
        listingUsed: state.listingUsed,
    };
}

export default connect(mapStateToProps)(VehicleTiles);



// WEBPACK FOOTER //
// ./client/src/containers/ResultVehicles/ResultVehicles.js